import { Box } from '@mui/material';
import MigrationDetailDTO from '@src/adapters/dto/migration/MigrationDetailDTO';
import Consultant from './consultant/Consultant';
import Procedure from './procedure/Procedure';
import Notes from './notes/Notes';
import MigrationNoteDTO from '@src/adapters/dto/migration/MigrationNoteDTO';
import IdNameDto from '@src/adapters/dto/shared/IdNameDto';
import { MigrationNoteType } from '@src/constants/MigrationNoteType';
import Scans from './scan/Scans';
import { MigrationStatus } from '@src/constants/MigrationStatus';

interface Props {
  migrationDetail: MigrationDetailDTO;
  onNoteUpdated(note: MigrationNoteDTO): void;
  onNoteDeleted(noteId: string): void;
  onProcedureUpdated(procedure: IdNameDto): void;
}

function DetailsTab({
  migrationDetail,
  onNoteUpdated,
  onNoteDeleted,
  onProcedureUpdated,
}: Props) {
  return (
    <>
      <Box
        sx={(theme) => ({
          padding: theme.spacing(3),
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing(2),
        })}>
        <Consultant
          migrationId={migrationDetail.id}
          consultant={migrationDetail.consultant}
          disabled={migrationDetail.status === MigrationStatus.Complete}
        />
        <Procedure
          migration={migrationDetail}
          procedureUpdated={onProcedureUpdated}
          disabled={migrationDetail.status === MigrationStatus.Complete}
        />
      </Box>
      <Box sx={{ paddingBottom: '20px' }}>
        <Notes
          migartionId={migrationDetail.id}
          notes={migrationDetail.notes.filter(
            (n) => n.type === MigrationNoteType.Scrub
          )}
          noteUpdated={onNoteUpdated}
          noteDeleted={onNoteDeleted}
          type={MigrationNoteType.Scrub}
          disabled={migrationDetail.status === MigrationStatus.Complete}
        />
        <Notes
          migartionId={migrationDetail.id}
          notes={migrationDetail.notes.filter(
            (n) => n.type === MigrationNoteType.General
          )}
          noteUpdated={onNoteUpdated}
          noteDeleted={onNoteDeleted}
          type={MigrationNoteType.General}
          disabled={migrationDetail.status === MigrationStatus.Complete}
        />
        <Notes
          migartionId={migrationDetail.id}
          notes={migrationDetail.notes.filter(
            (n) => n.type === MigrationNoteType.Migration
          )}
          noteUpdated={onNoteUpdated}
          noteDeleted={onNoteDeleted}
          type={MigrationNoteType.Migration}
          disabled={migrationDetail.status === MigrationStatus.Complete}
        />
        <Scans scanIds={migrationDetail.extraScanIds} />
      </Box>
    </>
  );
}

export default DetailsTab;
